import { zodResolver } from '@hookform/resolvers/zod'
import { useStoreMap } from 'effector-react'
import { useForm } from 'react-hook-form'
import { rentalContractModel } from '~/entities/RentalContract'
import { More } from '~/entities/RentalService'
import { $rentalServices } from '~/entities/RentalService/model'
import { RentalService } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import { Checkbox, FormProvider } from '~/shared/ui/form'
import { formSchema, FormValues } from '../model'
import { Wrapper } from './styled'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
}

export function Form({ onSuccess }: FormProps) {
  const rentalServices = useStoreMap($rentalServices, (rentalServices) =>
    (rentalServices || []).map((rentalService: RentalService) => ({
      id: rentalService.getApiId() as UniqueId,
      ...rentalService.getAttributes(),
    })),
  )

  const defaultValues = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => {
      const selectedRentalServices =
        rentalContract
          ?.getRentalServices()
          ?.filter((rentalService) => rentalService?.getIsEditForDriver()) || []

      return {
        rentalServices: selectedRentalServices.reduce(
          (acc: Record<string, boolean>, rentalServices) => {
            acc[rentalServices.getApiId() as string] = true
            return acc
          },
          {},
        ),
      }
    },
  )

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  })

  if (!rentalServices?.length) return <div>Услуги не найдены</div>

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Wrapper>
        {rentalServices.map((rentalService) => (
          <Checkbox
            key={rentalService.id}
            name={`rentalServices.${rentalService.id}`}
            label={rentalService.name}
            mode='md'
          />
        ))}
        <div style={{ paddingTop: '12px' }}>
          <More />
        </div>
      </Wrapper>

      <Button
        fullWidth
        type='submit'
        variant='limeFlooded'
        style={{ marginTop: '26px' }}
      >
        Применить
      </Button>
    </FormProvider>
  )
}
